
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epochs/[number]",
      function () {
        return require("private-next-pages/epochs/[number].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epochs/[number]"])
      });
    }
  